import React, { useCallback, type FC } from "react";

import { useIntl } from "react-intl";

import {
	Button,
	LINK_VARIANT_HIGHLIGHT,
	Link,
	Modal,
	ModalBody,
	ModalFoot,
	ModalHead,
} from "mailup-web-components";

import {
	useRecoilCallback,
	useRecoilValue,
	useResetRecoilState,
	useSetRecoilState,
} from "recoil";
import { importStatus, modalClauseImportState } from "../recoil/state";

import styled from "@emotion/styled";
import { notifyParent } from "mailup-react-helpers";
import { gainsightTrack } from "mailup-react-helpers";
import {
	pollingImportsCallback,
	startImportsCallback,
} from "../recoil/callbacks";

const ModalClauseImportState: FC = () => {
	const intl = useIntl();

	const { show } = useRecoilValue(modalClauseImportState);

	const reset = useResetRecoilState(modalClauseImportState);

	const startImports = useRecoilCallback(startImportsCallback, []);

	const startImport = () => {
		reset();
		gainsightTrack("mup_recipients_click_acceptImportTC", {});
		startImports();
	};

	return (
		<Modal show={show} onClose={reset}>
			<ModalHead
				title={intl.formatMessage({
					id: "Load.FileImportStatus.lblDeclare",
				})}
			/>
			<ModalBody>
				<ol>
					<Styledli>
						{intl.formatMessage({
							id: "Load.FileImportStatus.lblClasusola1",
						})}
					</Styledli>
					<Styledli>
						{intl.formatMessage({
							id: "Load.FileImportStatus.lblClasusola2",
						})}
					</Styledli>
					<Styledli>
						{intl.formatMessage({
							id: "Load.FileImportStatus.lblClasusola3",
						})}
					</Styledli>
					<Styledli>
						{intl.formatMessage({
							id: "Load.FileImportStatus.lblClasusola4",
						})}
					</Styledli>
					<Styledli>
						{intl.formatMessage(
							{
								id: "Load.FileImportStatus.lblClasusola5",
							},
							{
								link: (chunks) => (
									<Link
										variant={LINK_VARIANT_HIGHLIGHT}
										data-mu-test="fatture-in-cloud-disconnected"
										onClick={() => {
											notifyParent("redirectMainFrame", [
												"Accetta_Contratto.aspx?readonly=yes",
											]);
										}}
									>
										{chunks}
									</Link>
								),
							},
						)}
					</Styledli>
				</ol>
			</ModalBody>
			<ModalFoot>
				<Button onClick={startImport}>
					{intl.formatMessage({
						id: "Load.FileImportStatus.BottoneImportazione",
					})}
				</Button>
			</ModalFoot>
		</Modal>
	);
};

export default ModalClauseImportState;

const Styledli = styled.li`
    padding: 10px 0 5px;
    list-style: decimal outside none;
    margin: 0 0 0 16px;
    :first-child {
        padding-top: 0;
    }
`;
